module.exports = __webpack_public_path__ + "static/media/logo_adelante_andalucia.bb2586bf.svg";